// TextInputRef.js
// import React, { useEffect } from "react";
import React from "react";
import { Text, TextInput, View } from "react-native";
// import SuggestInput from "./SuggestInput";

const TextInputRef = React.forwardRef(({formrefs, refkey, data={}, dataid=null, datakey=null, editable=true, style={}, textstyle={}, textWrapperStyle={}, ismoney=false, isnumber=false, hidezero=true, readonly=false, onChange, onblur, urlKey, idValue=0, textValue, suggestedDataPresides=false, ..._props}, parentRef) => {

  const isSuggest = (!!urlKey || idValue>0 || (_props.hasOwnProperty("suggestInputData") && !!Array.isArray(_props.suggestInputData)));

  if (!isSuggest && !readonly && ((!formrefs || typeof(formrefs)!=="object" || !formrefs.hasOwnProperty("create")) && (!onChange || typeof(onChange)!=="function"))) {
    console.error("Missing required props: Requires either `formrefs` OR `onChange`.");
    return (null);
  }
  if (!!readonly && !!editable) {
    editable = false;
  }
  let _inputRef = null;
  let defVal = "";
  let defId = 0;
  if (!data || typeof(data)!=="object") {
    data = {};
  }
  refkey = (refkey || idValue || datakey);

  if (!!datakey && typeof(datakey)==="string" && !suggestedDataPresides) {
    if (!!dataid) {
      refkey = (datakey+"_"+data[dataid]);
    }
    if (!!formrefs && !!formrefs.getRef(refkey)?.current) {  // Updated 2022-10-04: re-ordered these IFs to check the REF first to prevent recent changes data loss on re-renders.
      if (!!isSuggest && !editable) {
        defVal = formrefs.getRef(refkey).current.textValue;
      } else {
        defVal = formrefs.get(refkey);
      }
    } else if (!!urlKey && typeof(textValue)!=="undefined") {
      defVal = textValue;
    } else if (data.hasOwnProperty(datakey)) {
      defVal = data[datakey];
    } else {
      defVal = (typeof(textValue)==="undefined"?"":textValue);
    }
  } else if (!!idValue && !!Object.keys(data).length && _props.hasOwnProperty("suggestInputData") && !!Array.isArray(_props.suggestInputData)) {
    const match = _props.suggestInputData.find(o=>(Number(o.id)===Number(data[idValue])));
    defVal = (!!match ? match.title : "");
    defId = (!!match ? match.id : 0);
  } else if (!Object.keys(data).length && !!idValue && _props.hasOwnProperty("suggestInputData") && !!Array.isArray(_props.suggestInputData)) {
    const match = _props.suggestInputData.find(o=>(Number(o.id)===Number(idValue)));
    if (!!match) {
      defVal = match.title;
      defId = match.id;
    }
  } else {
    datakey = null;
  }
  if (!!parentRef && parentRef.hasOwnProperty("current")) {
    if (!!refkey && !!formrefs) {
      _inputRef = formrefs.create(refkey,parentRef,(!!isSuggest ? null : (!!ismoney ? window.main.lib.decimalFormat(defVal) : (!!isnumber ? window.main.lib.numericOnly(defVal) : defVal))));
    } else {
      _inputRef = parentRef;
    }
  }
  if (!!defVal && !!textValue) {
    if (!isNaN(defVal)) {
      idValue = Number(defVal);
    }
    defVal = textValue;
  }
  if (!defVal && !!textValue) {
    defVal = textValue;
  }
  let _onChange = ()=>{};
  if (!!onChange && (typeof(onChange)==="function")) {
    _onChange = (v)=>{
      onChange(v,parentRef);
    }
  } else {
    _onChange = (v)=>{
      if(!!datakey) {
        if (!!ismoney) {
          v = window.main.lib.numericOnly(v);
        }
        if (!!isSuggest && typeof(v)==="object") {
          const _ref = formrefs.getRef(refkey);
          _ref.current.value = v.id;
          _ref.current.textValue = v.title;
        } else {
          formrefs.set(refkey,(!!v && isNaN(v) ? v.toString() : v));  // Update the FormRef
        }
        if (!isSuggest && data?.hasOwnProperty(datakey)) {
          data[datakey] = (!!v && !isNaN(v) ? v.toString() : v);  // Update the data source
        }
      }
    };
  }

  if ((!onblur || (typeof(onblur)!=="function")) && (!!ismoney||!!isnumber)) {
    onblur = (e)=>{
      if (!!ismoney) {
        const fv = window.main.lib.decimalFormat(e.target.value);
        if (!!formrefs) {
          formrefs.set(refkey,fv);  // Update the FormRef
        }
      } else if (!!isnumber) {
        const fv = window.main.lib.numericOnly(e.target.value);
        if (!!formrefs) {
          formrefs.set(refkey,fv);  // Update the FormRef
        }
      }
    };
  }

  if (!(Object.keys(textstyle).length)) {
    textstyle = {...window.main.theme.sectionGridItemText, lineHeight:17};
  }

  let props = {..._props};  // Clone local variable object in memory.

  // useEffect(()=>{
    if (!!editable) {
      window.setTimeout(()=>{
        if (!!isSuggest) {  // One instanced of TextInputRef as isSuggest is in Edit Sheet Details - 'Sheet Type'. This is somewhat untested.
          if (!!formrefs) {
            const _ref = formrefs.getRef(refkey);
            if (!!_ref?.current) {
              _ref.current.value = (Number(defId)||0).toString();
              _ref.current.textValue = (defVal||"")?.toString();
            }
          }
        } else {
          if (!!formrefs) {
            formrefs.set(refkey,(!!ismoney ? window.main.lib.decimalFormat(defVal) : (defVal||"")).toString());
          }
        }
      },1);
    }
  // },[editable,isSuggest,formrefs,_inputRef]);
  // },[]);

  const _defaultValue = (!!ismoney ? window.main.lib.decimalFormat(defVal) : (!!isnumber&&!hidezero ? window.main.lib.decimalFormat(defVal) : defVal));
  if (!!editable && !!isSuggest && typeof(defVal)==="object" && defVal.hasOwnProperty("props") && typeof(defVal.props.children)==="string") {
    defVal = defVal.props.children;
  }
  return (
    <>
      {!editable &&
        <View style={{...textWrapperStyle}}><Text style={{...textstyle}} numberOfLines={1} {...props}>{!!ismoney ? window.main.lib.dollarFormat(_defaultValue) : ((!!isnumber && !hidezero) ? window.main.lib.numberFormat(_defaultValue) : _defaultValue)}</Text></View>
      }
      {!!editable && !isSuggest &&
        <TextInput ref={_inputRef} style={{...style}} defaultValue={_defaultValue} onChangeText={_onChange} onBlur={onblur} maxLength={(!!ismoney ? 12 : null)} {...props} />
      }
      {/* {!!editable && !!isSuggest &&
        <SuggestInput ref={_inputRef} value={{id: Number(defId), title: defVal}} urlKey={urlKey} onChange={_onChange} style={style} containerStyle={{paddingRight:0}} {...props}>{_props.children}</SuggestInput>
      } */}
    </>
  );
});

export default TextInputRef;
